import React, { useState } from 'react';
import TabContext from '@mui/lab/TabContext';

import { useSelector } from 'react-redux';
import { selectCommandByNodeId, State } from '@store/index';
import { TabList, TabPanel } from '@mui/lab';
import { Tab } from '@mui/material';
import { SingleSwitch } from '@common/Node/NodeSidebar/Logic/SingleSwitch';
import { NodeFieldType } from '../../';
import { NodeInputExpression, NodeSidebar, NodeSidebarTab, NodeSidebarTabsContainer } from '@common/Node/NodeSidebar';
import { NodeData } from '@common/Node/NodeSidebar/NodeData';
import { ArticleOutlined } from '@mui/icons-material';

export const BranchTabs: React.FC = () => {
  const [tab, setTab] = useState('1');

  const command = useSelector((state: State) => selectCommandByNodeId(state, state.tabs.active.selectedNode));
  if (!command) return null;

  const fields = command.fields;
  const inputs = fields.filter((field) => field.tab === '1' && field.type !== NodeFieldType.Condition);
  const condition = fields.find((field) => field.type === NodeFieldType.Condition);

  return (
    <NodeSidebar>
      <TabContext value={tab}>
        <NodeSidebarTabsContainer color={command.config.background}>
          <TabList onChange={(_, newTab) => setTab(newTab)}>
            <Tab disableRipple label='Node' value='1' />
            <Tab title='Data' disableRipple iconPosition='start' icon={<ArticleOutlined />} value='2' />
          </TabList>
        </NodeSidebarTabsContainer>
        <TabPanel value='1'>
          <NodeSidebarTab>
            {inputs && inputs.map((field) => <NodeInputExpression key={field.id} field={field} command={command} />)}
            {condition && <SingleSwitch field={condition} command={command} />}
          </NodeSidebarTab>
        </TabPanel>
        <TabPanel value='2'>
          <NodeData command={command} />
        </TabPanel>
      </TabContext>
    </NodeSidebar>
  );
};
